import { Grid } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';
import { V } from '../../common/Layout';
import { ProductionTypeSuperset } from '../helpers/productionApi';
import { AssociatedKeyDates } from './AssociatedKeyDates';
import { AssociatedKeyPeople } from './AssociatedKeyPeople';
import { AssociatedOrganizations } from './AssociatedOrganizations';

type ProductionAssociatedEntitiesProps = {
    workspace: ProductionTypeSuperset;
    setWorkspace?: Dispatch<SetStateAction<ProductionTypeSuperset>>;
    isReadOnly?: boolean;
    isSaving?: boolean;
};

export const ProductionAssociatedEntities = ({
    workspace,
    setWorkspace,
    isReadOnly,
    isSaving
}: ProductionAssociatedEntitiesProps) => {
    const { keyPeople, keyOrganizations, reference, linkedPeople, associatedOrgs, name } = workspace;

    return (
        <V gap={1.5}>
            <Grid size={{ xs: 12 }}>
                <AssociatedKeyPeople
                    keyPeople={keyPeople || []}
                    workspaceReference={reference}
                    associatedPeople={linkedPeople?.map((person) => person.contact) || []}
                    workspaceName={name}
                    setViewState={setWorkspace}
                    isReadOnly={isReadOnly}
                    isSaving={isSaving}
                />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <AssociatedKeyDates
                    workspace={workspace}
                    setWorkspace={setWorkspace}
                    isReadOnly={isReadOnly}
                    isSaving={isSaving}
                />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <AssociatedOrganizations
                    keyOrganizations={keyOrganizations || []}
                    associatedOrganizations={associatedOrgs}
                    workspaceId={reference.id}
                    setWorkspace={setWorkspace}
                    isReadOnly={isReadOnly}
                    isSaving={isSaving}
                />
            </Grid>
        </V>
    );
};
